export default __webpack_public_path__ + "static/media/Step3.34b6d77e.png";